export default "__VITE_ASSET__DAuZP6WP__"